module.exports = __webpack_public_path__ + "static/media/icon-settings-metacx.5a1a60a4.svg";